import L from "leaflet";

/** Tile file extension from slide File row (upload-photo uses .jpg). */
export function tileExtensionFromSlideFile(file) {
  if (!file) return "png";
  const name = String(file.name || "").toLowerCase();
  const type = String(file.type || "").toLowerCase();
  if (/\.(jpe?g)$/.test(name) || type.includes("jpeg")) return "jpg";
  if (/\.webp$/.test(name) || type.includes("webp")) return "webp";
  if (/\.png$/.test(name) || type.includes("png")) return "png";
  if (name.startsWith("upload-photo")) return "jpg";
  return "png";
}

/** Leaflet tile URL pattern from slide File row. */
export function tileUrlPatternFromSlideFile(file) {
  if (!file?.url) return "";
  const base = String(file.url).replace(/\/+$/, "");
  const ext = tileExtensionFromSlideFile(file);
  return `${base}/{z}/{x}/{y}.${ext}`;
}

export function tileUrlPatternFromRoot(tileRootUrl, tileExt = "png") {
  const base = String(tileRootUrl || "").replace(/\/+$/, "");
  const ext = String(tileExt || "png").replace(/^\./, "");
  return `${base}/{z}/{x}/{y}.${ext}`;
}

export function isUploadPhotoSlide(slideOrGeoJson) {
  const file = slideOrGeoJson?.Files?.[0];
  const name = String(file?.name || file?.alias || "").toLowerCase();
  return name.startsWith("upload-photo");
}

/** Center map on 0/0 pyramid tiles (upload-photo), not library geo anchor. */
export function uploadPhotoLeafletView(map, maxNativeZoom) {
  let z = Math.max(0, Number(maxNativeZoom));
  if (!Number.isFinite(z)) z = 4;
  // Slides often keep default max_zoom=10 in DB; uploaded photos are usually <= ~6.
  if (z > 8) z = 4;
  if (z === 0) {
    return { center: [0, 0], zoom: 0 };
  }
  const center = map.unproject(L.point(128, 128), z);
  const viewZoom = Math.max(0, z - 1);
  return {
    center: [center.lat, center.lng],
    zoom: viewZoom,
  };
}

/** Library / title grid cover image (deep-zoom preview tile). */
export function slideThumbnailUrlFromSlide(slide) {
  const file = slide?.Files?.[0];
  if (!file?.url) return null;
  const base = String(file.url).replace(/\/+$/, "");
  const ext = tileExtensionFromSlideFile(file);
  return `${base}/3/3/3.${ext}`;
}
